import Data from 'data';
import { AuraFlags, d2_percent, missileFormula, skillAuraStats, skillCalc, skillFormula, skillPassiveStats } from 'logic/skills/calc';
import { AnimationCalculator } from '../animation';
import { DamageCalculator, missileDamage } from '../damage';
import { DPSCalculator, missileDPS } from '../dps';

const functions = {};

// Static Field

functions[20] = {
  damage(skill, stats, weapon, level, target) {
    const maxhp = target?.base?.maxhp || 0;
    const damage = new DamageCalculator(stats, weapon, false, false);
    damage.skillbonus('lightmindam', skillFormula(skill, 'clc2', stats, level));
    damage.skillbonus('lightmaxdam', d2_percent(maxhp << 8, skillFormula(skill, 'clc1', stats, level)));
    return damage.calculate(target, true);
  },
  dps: () => null,
};

// Telekinesis

functions[21] = {
  damage(skill, stats, weapon, level, target) {
    const calc = new DamageCalculator(stats, weapon, false, false);
    calc.elemental(skill.etype, skillFormula(skill, 'enms', stats, level),
      skillFormula(skill, 'exms', stats, level), skillFormula(skill, 'edln', stats, level));
    return calc.calculate(target);
  },
};

// Frost Nova, Nova, Poison Nova, Howl

functions[22] = {
  info(id, stats, level, target) {
    const skill = Data.skills[id];
    const missile = Data.missileByName[skill.srvmissilea];
    if (!missile) return;
    const damage = missileDamage(missile, stats, stats.weapon1, level, target);
    if (!damage || !Object.values(damage).some(Boolean)) return;
    return {
      damage,
      animation: new AnimationCalculator(stats, skill).calculate(),
    };
  },
  dps(id, stats, level, target, info) {
    const skill = Data.skills[id];
    const missile = Data.missileByName[skill.srvmissilea];
    if (!missile) return;
    return missileDPS(skill, missile, stats, level, target, info);
  },
};

// Blaze, Energy Shield

functions[23] = {
  damage(skill, stats, weapon, level, target) {
    const missile = Data.missileByName[skill.srvmissilea];
    if (!missile) return;
    return missileDamage(missile, stats, weapon, level, target, {frames: missileFormula(missile, 'rang', stats, level)});
  },
  animation() {},
  dps() {},
  buff(id, stats, level) {
    const skill = Data.skills[id];
    return {
      level,
      state: skill.aurastate,
      stats: () => skillPassiveStats(skill, stats, level),
    };
  },
};

// Fire Wall

functions[24] = {
  damage(skill, stats, weapon, level, target) {
    const missile = Data.missileByName[skill.srvmissileb];
    if (!missile) return;
    return missileDamage(missile, stats, weapon, level, target, {frames: missileFormula(missile, 'rang', stats, level) - 1});
  },
  dps(id, stats, level, target, info) {
    if (!info?.damage || !info?.animation) return;
    const calc = new DPSCalculator();
    calc.damage('damage', info.damage.damage, {interval: info.animation.fpa, count: target.size === 1 ? 1 : 3, duration: info.damage.damage.frames, stackable: true});
    return calc.calculate(stats, target);
  },
};

// Enchant

functions[25] = {
  targetFilter: AuraFlags.FindPlayers | AuraFlags.FindMonsters | AuraFlags.TargetAllies,
  buff(id, stats, level, targets) {
    if (!targets || !targets.length) return;
    const skill = Data.skills[id];
    return {
      level,
      targets,
      targetState: skill.aurastate,
      targetStats: () => skillAuraStats(skill, stats, level),
    };
  },
};

// Chain Lightning

functions[26] = {
  damage(skill, stats, weapon, level, target) {
    return missileDamage(Data.missileByName[skill.srvmissilea], stats, weapon, level, target);
  },
};

// Meteor, Blizzard, Eruption

functions[28] = {
  damage(skill, stats, weapon, level, target) {
    return missileDamage(Data.missileByName[skill.srvmissilea], stats, weapon, level, target, {fireFrames: skillFormula(skill, 'ln34', stats, level) - 1});
  },
  dps(id, stats, level, target, info) {
    const skill = Data.skills[id];
    const missile = Data.missileByName[skill.srvmissilea];
    if (!missile) return;
    return missileDPS(skill, missile, stats, level, target, info);
  },
};

// Thunder Storm

functions[29] = {
  damage(skill, stats, weapon, level, target) {
    return missileDamage(Data.missileByName[skill.srvmissilea], stats, weapon, level, target);
  },
  animation() {},
  dps(id, stats, level, target, info) {
    if (!info?.damage) return;
    const skill = Data.skills[id];
    const calc = new DPSCalculator();
    const delay = skillCalc(skill, skill.perdelay, stats, level);
    calc.damage('damage', info.damage.damage, {interval: delay});
    return calc.calculate(stats, target);
  },
};

export default functions;
